( function( $ ) { 
	$(document).ready(function() {
		$('a[href*="#"].last-tab, a[href*="#"].next-tab').on('click', function(e) {
		  e.preventDefault();
		  
		  $('html, body').animate(
		    {
		      scrollTop: $($(this).attr('href')).offset().top,
		    },
		    200,
		    'linear'
		  );
		});

		$('.show-spitzen-abo-konfigurator').click(function() {
			$('#spitzen-abo-konfigurator').css('display', 'block');
			$('#es-price-slider').insertAfter($('#spitzen-abo-konfigurator .elementor-widget-es-summary'));
			$('.es-konfigurator-simple').css('display', 'none');
		});

		$('.next-tab').click(function() {
			$(this).closest('.elementor-tabs').find('.elementor-tab-title.elementor-active').next().click();
		});
		$('.last-tab').click(function() {
			$(this).closest('.elementor-tabs').find('.elementor-tab-title.elementor-active').prev().click();
		});

		$('[data-set-price]').click(function() {
			document.querySelector('.elementor.product main').__vue__.setPrice($(this).data('setPrice'))
			$('[data-set-price]').removeClass('selected')
			$(this).addClass('selected');
			if($(this).data('scroll') !== 'no') {
				$('html').animate(
			    {
			      scrollTop: $('#es-start-config').offset().top,
			    },
			    200,
			    'linear'
			  );			
			} else {
				$('html').animate(
			    {
			      scrollTop: $(this).offset().top - 20,
			    },
			    200,
			    'linear'
			  );	
			}
		})
	});
} )( jQuery );


var escApp = new Vue({
	el: '.elementor.product main',
	data () {
		return {
			products: [],
			styles: [{"id":836,"name":"Soft Nature","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/1.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":1516,"name":"Spring Feelings","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/2.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":1517,"name":"Summer Moments","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/6.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":827,"name":"Romantik Pleasure","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/romantik-pleasure.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":833,"name":"Boho Vibes","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/3.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":834,"name":"Candy World","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/8.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":837,"name":"Simple Basic","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/7.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":835,"name":"Say Ahoi","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/10.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":1519,"name":"Autumn Love","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/4.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false},{"id":1518,"name":"Frozen World","images":["https:\/\/einfachspitze.imgix.net\/2022\/03\/5.svg?auto=compress%2Cformat&fit=scale&h=300&ixlib=php-3.3.1&q=70&w=300&wpsize=medium"],"imageIndex":0,"selected":false}],
			colors: [],
			notes: "",
			persons: [{
				sex: null,
				age: null
			}],
			lengths: {
				fabrics: {
					min: 1,
					max: 2,
					untouched: true
				}, 
				haberdashery: {
					min: 1.5,
					max: 2.5,
					untouched: true
				}
			},
			price: [],
			subscriptions: {
				intervals: [],
				lengths: [],
				selectedInterval: null,
				selectedLength: null
			},
			doNotWatch: false,
			priceTimeout: null,
			isSubscription: 'yes'
		};
	},
	mounted () {
		jQuery
			.get('https://einfachspitze.de/wp-json/es-conf/v1/products/' + esProduct.id)
			.then(response => (this.products = Object.values(response)));
		jQuery
			.get('https://einfachspitze.de/wp-json/es-conf/v1/styles')
			.then(response => (this.styles =  Object.values(response)));
		jQuery
			.get('https://einfachspitze.de/wp-json/es-conf/v1/colors')
			.then(response => (this.colors =  Object.values(response)));
		jQuery
			.get('https://einfachspitze.de/wp-json/es-conf/v1/prices/' + esProduct.id)
			.then(response => {
				this.price =  response;
				if(!this.price.max || this.price.max === "") {
					this.price.max = 100;
				}

				this.price.min = parseInt(this.price.min);
				this.price.max = parseInt(this.price.max);
				this.price.value = parseInt(this.price.value);
				this.initPriceSlider();
			});
		jQuery
			.get('https://einfachspitze.de/wp-json/es-conf/v1/subscription-schemes/' + esProduct.id)
			.then(response => {
				let intervals =  Object.values(response).map(s => s.interval + "_" + s.period);

				intervals = [...new Set(intervals)];

				this.subscriptions.intervals = intervals.map(k => {
					let parts = k.split("_");

					return {
						"key": k,
						"interval": parseInt(parts[0]),
						"period": parts[1],
						"title": "jede" + (parts[1] === "month" ? "n" : "") + (parts[0] === "1" ? " " : " " + parts[0] + ". ") + (parts[1] === "week" ? "Woche" : "Monat")
					};
				});

				this.subscriptions.selectedInterval = intervals[0];
				

				let lengths = response.map(s => s.period + "_" + s.length);

				lengths = [...new Set(lengths)];

				this.subscriptions.lengths = lengths.map(k => {
					let parts = k.split("_");

					return {
						"key": k,
						"length": parseInt(parts[1]),
						"period": parts[0],
						"title": parts[1] + " " + (parts[0] === "week" ? "Wochen" : "Monate")
					};
				});

				this.subscriptions.selectedLength = lengths[0];
			});

			jQuery
				.get('https://einfachspitze.de/wp-json/es-conf/v1/product-conf/' + esProduct.id)
				.then(response => {
					if(response) {
						let r = JSON.parse(response);
						this.loadSettings(r);
					}
				});
	},
	methods: {
        select: function(scope, value, filter = null) {
        	if(scope === "products") {
        		if(filter) {
        			this.products.forEach(p => p.selected = false);
        			this.products.filter(p => p.catFilter === filter).forEach(p => p.selected = value);
        		} else {
        			this.products.forEach(p => p.selected = value);
        		}
        	} else if (scope === "styles") {
        		this.styles.forEach(s => s.selected = value);
        	} else if (scope === "colors") {
        		this.colors.forEach(c => c.selected = value);
        	}
        },
        lowerPrice: function(by = 1) {
        	this.price.value = parseInt(this.price.value) - by;
        	this.updatePriceSlider();
        },
        raisePrice: function(by = 1) {
        	this.price.value = parseInt(this.price.value) + by;
        	this.updatePriceSlider();
        },
        setPrice: function(size = "s") {
        	if(size === "s") {
        		this.price.value = this.price.min;
        	} else if(size === "m") {
        		this.price.value = this.price.max / 2;
        	} else if(size === "l") {
        		this.price.value = this.price.max;
        	} else if(typeof size === 'number') {
        		this.price.value = size;
        	}
        	this.updatePriceSlider();
        },
	    updatePriceSlider: function() {
	    	if (typeof this.$refs.esPriceSlider === 'undefined') return;
	    	this.$refs.esPriceSlider.noUiSlider.set(parseInt(this.price.value));
	    },
	    updateLengthSlider: function() {
	    	this.$refs.esLengthSliderHaberdashery.noUiSlider.set([this.lengths.haberdashery.min, this.lengths.haberdashery.max]);
	    	this.$refs.esLengthSliderFabrics.noUiSlider.set([this.lengths.fabrics.min, this.lengths.fabrics.max]);
	    },
	    addPerson: function() {
	    	this.persons.push({
				sex: null,
				age: null
			});
	    },
	    removePerson: function(index) {
	    	this.persons.splice(index, 1);
	    },
	    getSettings: function() {
	    	let settings = {
        		products: this.products.filter(p => p.selected).map(p => p.id),
				styles: this.styles.filter(s => s.selected).map(s => s.id),
				colors: this.colors.filter(c => c.selected).map(c => c.name),
				persons: this.selectedPersons === "" ? [] : this.persons,
				lengths: Object.keys(this.lengths).filter(l => !this.lengths[l].untouched).map(l => this.lengths[l]),
				notes: this.notes
        	};

        	Object.keys(settings).forEach((key) => (settings[key] === null || settings[key].length === 0 || settings[key] === "") && delete settings[key]);

        	alert(JSON.stringify(settings));
        	return settings;
	    },
	    loadSettings: function(settings) {
    		Object.keys(settings).forEach(k => {
    			if(this[k] === null) {
    				return;
    			}

    			if(["products", "styles"].includes(k)) {
    				this[k].filter(i => settings[k].includes(i.id)).forEach(i => i.selected = true);
    			} else if(k === "colors") {
    				this[k].filter(i => settings[k].includes(i.name)).forEach(i => i.selected = true);
    			} else {
    				this[k] = settings[k];
    			}
    		});
	    },
        saveToLocalStorage: function() {
        	let ls = JSON.parse(localStorage.getItem("escAppData")) || new Object();

        	ls["p" + esProduct.id] = this.getSettings();

        	localStorage.setItem("escAppData", JSON.stringify(ls));
        },
        loadFromLocalStorage: function() {
        	let data = JSON.parse(localStorage.getItem("escAppData"));
        	if(data["p" + esProduct.id] === null) {
        		return;
        	}

        	try {
        		this.loadSettings(data["p" + esProduct.id]);

	        	this.updateLengthSlider();
	        	this.updatePriceSlider();
        	} catch(e) {
        		localStorage.removeItem("escAppData");
        	}
        },
        setLengths: function(slType, slMin, slMax) {
        	console.log(slType + ": " + slMin + " - " + slMax);
        	this.doNotWatch = true;
        	this.lengths[slType].min = slMin;
        	this.lengths[slType].max = slMax;
        	this.doNotWatch = false;
        },
        initPriceSlider: function() {
	    	this.$refs.esPriceSlider.noUiSlider.updateOptions({
				range: {
				    'min': [parseInt(this.price.min)],
				    '43%': [50],
				    'max': [parseInt(this.price.max)]
				}
			});
        }
	},
	computed: {
		step1Valid: function() {
			return this.products.length > 0 && this.styles.length > 0 && this.colors.length > 0;
        },
		selectedProducts: function() {
			return this.products.filter(p => p.selected);
        },
		selectedStyles: function() {
			return this.styles.filter(s => s.selected);
        },
		selectedColors: function() {
			return this.colors.filter(c => c.selected);
        },
        selectedPersons: function() {
        	let s = this.persons.map(p => p.sex + " (" + p.age + ")").join(", ");
        	return s === "null (null)" ? "" : s;
        },
        selectedFabricsLength: function() {
        	let f = this.lengths.fabrics;
        	return `${f.min}m - ${f.max}m`;
        },
        selectedHaberdasheryLength: function() {
        	let h = this.lengths.haberdashery;
        	return `${h.min}m - ${h.max}m`;
        },
        sliderPercent: function() {
        	let p = this.price;
        	if(parseInt(p.value) < 50) {
        		return (parseInt(p.value) - parseInt(p.min)) / (50 - parseInt(p.min)) * 0.5;
        	} else {
        		return (parseInt(p.value) - 50) / (parseInt(p.max) - 50) * 0.5 + 0.5;
        	}
        	
        },
        selectedSubscriptionInterval: function() {
        	if(this.subscriptions.selectedInterval) {
        		return this.subscriptions.intervals.find(i => i.key === this.subscriptions.selectedInterval);
        	} 
        	return {
				"key": "",
				"interval": "",
				"period": "",
				"title": ""
			};
        },
        selectedSubscriptionLength: function() {
        	if(this.subscriptions.selectedLength) {
        		return this.subscriptions.lengths.find(i => i.key === this.subscriptions.selectedLength);
        	} 
        	return {
				"key": "",
				"length": "",
				"period": "",
				"title": ""
			};
        },
        subscriptionTheme: function() {
        	if(this.isSubscription === 'no') return '0';
        	if(this.selectedSubscriptionInterval && this.selectedSubscriptionLength) {
        		if(isNaN(this.selectedSubscriptionLength.length)) return this.selectedSubscriptionInterval.key;
        		return this.selectedSubscriptionInterval.key + "_" + this.selectedSubscriptionLength.length;
        	}
        	return null;
        },
        haberdasherySelected: function() {
        	return this.selectedProducts.map(p => p.catFilter).includes("h");
        }, 
        fabricsSelected: function() {
        	return this.selectedProducts.map(p => p.catFilter).includes("f");
        },
        packageCount: {
        	get() {
	        	if(this.selectedSubscriptionInterval && this.selectedSubscriptionLength) {
	        		return parseInt(this.selectedSubscriptionLength.length) / parseInt(this.selectedSubscriptionInterval.interval);
				}
				return 0;
			}, 
			set(value) {
				while(this.packageCount < value) {
					
				}
			}
        }/*,
        minPrice: function() {
			let factors = {
				f: parseFloat(this.lengths.fabrics.min),
				h: parseFloat(this.lengths.haberdashery.min),
				t: 1
			}
			
			let selected = []

			if(typeof this.products === "array") {
				let selected = this.products.filter(p => p.selected)
			}

			// Wenn keine Produkte gewählt wurden, können alle Produkte in den Kalender
			if(selected.length === 0) {
				return this.price.min
			}

			let price = selected.map(p => parseFloat(p.avgPrice) * factors[p.catFilter] * (24 / selected.length))
        						.reduce((a, b) => (a + b), 0)

        	return Math.ceil((7 + price) / 10 ) * 10
        }*/
    },
    watch: {
    	selectedSubscriptionInterval: {
    		handler: function() {
    			if(this.selectedSubscriptionInterval.period !== this.selectedSubscriptionLength.period) {
    				this.subscriptions.selectedLength = this.subscriptions.lengths.filter(l => l.period === this.selectedSubscriptionInterval.period)[0].key;
    			}
    		}
    	},
    	lengths: {
    		handler: function() {
    			if(!this.doNotWatch) {
    				//this.updateLengthSlider();
    			}
    		},
    		deep: true
    	},
    	price: {
    		handler: function() {
    			if(this.priceTimeout !== null) {
    				clearTimeout(this.priceTimeout);
    			}
    			this.priceTimeout = setTimeout(this.updatePriceSlider, 1000);
    		},
    		deep: true
    	},
    	minPrice : {
    		handler: function() {
    			if(esProduct.id === "34737") {
    				this.price.min = this.minPrice

    				if(this.price.min > this.price.value) {
    					this.price.value = this.price.min
    				}
    			}

    		}
    	}
    }, 
    filters: {
    	priceFormat: function(value, printUnit = false, catFilter = "") {
    		return parseFloat(value).toFixed(2).replace(".", ",") + " €" + (printUnit ? (catFilter === "t" ? " / Tür" : " / m") : "")
    	}
    }
});

let loader = function (src) {
	return new Promise(function (resolve, reject) {
		let img = new Image();

		img.onload = function () {
		// resolve the promise with our url
			resolve(src);
		};
		img.onerror = function (err) {
			reject(err);
		};
		img.src = src;
	});
};

escApp.styles.forEach(style => {
	style.images.forEach(img => {
		loader(img);
	});
});

setInterval(function() {
	escApp.styles.forEach(style => {
		style.imageIndex  = ++style.imageIndex % style.images.length;
	});
}, 5000);